define('GameDayCore/GDModel/ValueObjects/Resources/MidInningGame',['require','exports','module','../ValueObjectFactory','../../../GDUtil/window/Logg','../../../GDControl/GameModelLocator/GameModelLocator','../../../GDUtil/resources/GDConfig'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
		logg = require("../../../GDUtil/window/Logg"),
		GameModelLocator = require('../../../GDControl/GameModelLocator/GameModelLocator'),
		GDConfig = require("../../../GDUtil/resources/GDConfig");

	VO.create(MidInningsGame);

	function MidInningsGame($data) {
		var vo = VO.ensureVO(this, MidInningsGame),
			data = $data,
			gameType,
			slots = [].concat(data.slot),
			inning = null,
			topInning = null,
            slot,
            midInningGame = null;

		if (!GDConfig.initProps.gumboMode) {
			var plays = GameModelLocator.getGameData("play").play;
			inning = plays.inning;
			topInning = (plays.half_inning === "top") ? "Y" : "N";
		} else {
			var game = GameModelLocator.getGameData().liveData;
			inning = game.linescore.currentInning;
			topInning = (game.linescore.inningState.toLowerCase() === "top" || game.linescore.inningState.toLowerCase() === "end");
		}

		for (var i = 0, l = slots.length; i < l; i++) {
			slot = slots[i];

			if (slot.inning == inning && slot.active.toUpperCase() === "Y" && slot.top_inning === topInning) {
				logg.log("slot.game :: " + slot.game.type);
				midInningGame =  slot;
			}
		}
		// midInningGame = null;

		vo.slot = midInningGame;
	}

	return MidInningsGame;
});
